module.exports = __webpack_public_path__ + "static/media/received_427461033551410 (1).0262fcc1.jpeg";